module.exports = {"id":"199835","name":"Emmanuel Emenike","rating":"74","photo":"./data/images/photos/2/199835.png","club":{"name":"UD Las Palmas","logo":"./data/images/clubs/UDLasPalmas.png"},"positions":["BU","MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EmmanuelEmenike0.json
// module id = 1240
// module chunks = 0